// extracted by mini-css-extract-plugin
export default {"card":"CardServices_card__WOY6x","service":"CardServices_service__EUlJe","service_detail":"CardServices_service_detail__Bebrr","active":"CardServices_active__q+QmM"};